import api from './api';

class CartService {
    // Get cart items
    async getCart() {
        try {
            const response = await api.get('/cart');
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Add item to cart
    async addToCart(productCode, quantity = 1, size = null) {
        try {
            const response = await api.post('/cart/add', { productCode, quantity, size });
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Add multiple items to cart
    async addMultipleToCart(products) {
        try {
            const promises = products.map(product => 
                this.addToCart(product.ProductCode, product.quantity || 1)
            );
            await Promise.all(promises);
            return { success: true, message: 'Products added to cart' };
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Update cart item quantity
    async updateQuantity(cartId, quantity) {
        try {
            const response = await api.put(`/cart/${cartId}/quantity`, { quantity });
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Update cart item size
    async updateSize(cartId, size) {
        try {
            const response = await api.put(`/cart/${cartId}/size`, { size });
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Remove item from cart
    async removeFromCart(cartId) {
        try {
            const response = await api.delete(`/cart/${cartId}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Clear entire cart
    async clearCart() {
        try {
            const response = await api.delete('/cart');
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }
}

export default new CartService();
